<template>
  <v-dialog v-model="innerIsShow" max-width="500px" @keydown.enter="exportTickets" @click:outside="
  innerIsShow = false;
$emit('update:isShow', false);
  ">
    <v-card>
      <v-card-title> Export Options </v-card-title>
      <v-card-text>
        <!-- <v-text-field
          placeholder="e.g MyCoolTicketReport"
          v-model="exportOptions.fileName"
        >
        </v-text-field> -->
        <v-radio-group v-model="exportOptions.fileType" row>
          <v-radio label="CSV" value="csv"></v-radio>
          <v-radio label="PDF" value="pdf"></v-radio>
        </v-radio-group>
        <v-checkbox label="Include Threads" v-model="exportOptions.showThreads">
        </v-checkbox>
        <v-checkbox label="Show Latest Comment" v-model="exportOptions.showComment">
        </v-checkbox>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" block @click="exportTickets" :loading="isExportLoading">
          Export
          <v-icon class="ml-2"> mdi-table-arrow-down </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import * as genUtilities from "../../../utilities/GeneralUtilities";
import parse from 'date-fns/esm/parse';
export default {
  watch: {
    isShow() {
      this.innerIsShow = this.isShow;
    },
    productSku(newValue, oldValue) {
      //get the meta data of the product

      this.$courier.Companies.withId(this.companyId).Products.getData(1, 1, this.productSku).then(resp => {
        //now get the meta data

        if (resp) {
          this.$courier.Products.withId(resp.payload[0].id).MetaData.getData(1, 100, '').then(mResp => {
            if (mResp && mResp.payload) {
              var rawResp = mResp.payload;

              for (var r of rawResp) {
                var parsed = JSON.parse(r.value.replaceAll("\\", "").replaceAll("ZohoCategories:", ""));

                for (var c of parsed) {
                  if (!this.includedCategoriesInProduct.some(x => x == c)) {
                    this.includedCategoriesInProduct.push(c);
                  }
                }
              }
            }
          })
        }
      })
    }
  },
  props: {
    productSku: {
      type: String,
      default: ''
    },
    byTime: {
      type: Boolean,
      default: false,
    },
    startDate: {
      type: Date,
      default: () => new Date(),
    },
    endDate: {
      type: Date,
      default: () => new Date(),
    },
    companyId: {
      type: String,
      default: "",
    },
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  methods: {
    async getFileName() {
      var comp = await this.getCompany();

      var r = comp.name;

      r = r.concat(
        " - From ",
        this.startDate.toLocaleDateString("en-GB"),
        " - To ",
        this.endDate.toLocaleDateString("en-GB")
      );
      return r;
    },
    async getCompany() {
      return await this.$courier.Companies.getById(this.companyId);
    },
    exportTickets() {
      this.isExportLoading = true;
      if (this.exportOptions.fileType == "csv") {
        this.exportTicketsWithThreadsAsCSV().then(() => {
          this.isExportLoading = false;
        });
      } else if (this.exportOptions.fileType == "pdf") {
        this.exportTicketsAsPDF().then(() => {
          this.isExportLoading = false;
        });
      }
    },
    async exportTicketsAsPDF() {
      var fileName = await this.getFileName();

      pdfMake.vfs = pdfFonts.pdfMake.vfs;

      var ticketDataConfig = {
        startDate: this.startDate.toISOString(),
        endDate: this.endDate.toISOString(),
        includeThreads: this.exportOptions.showThreads,
        companyId: this.companyId,
        includeLatestComment: this.exportOptions.showComment,
      };

      var resp = {};

      if (this.byTime) {
        resp = await this.$courier.Zoho.TicketDataByTime(ticketDataConfig);
      } else {
        resp = await this.$courier.Zoho.TicketData(ticketDataConfig);
      }

      var payload = await resp.json();

      var data = payload.payload;

      var docDefinition = {
        pageOrientation: "portrait",
        content: [],
        margin: 1,
      };

      docDefinition.content.push(
        {
          image:
            "data:image/png;base64,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",
          alignment: "right",
          width: 50,
        },
        {
          text: [
            {
              text: data[0].parentCompanyNameAsString + " Ticket Report",
              alignment: "center",
            },
            {
              text:
                "\n\nFrom Dates: " +
                new Date(this.startDate).toLocaleDateString("en-GB") +
                " To: " +
                new Date(this.endDate).toLocaleDateString("en-GB"),
              alignment: "center",
            },
          ],
        },
        {
          text: [
            {
              text: '\n\nTotal Time: ' + data.reduce((acc, currentValue) => {
                return parseInt(acc) + parseInt((currentValue.timeEntrySum ? currentValue.timeEntrySum : 0));
              }, 0) + ' Minutes',
              alignment: 'center'
            }
          ]
        }
      );

      docDefinition.content.push({
        text: "\n\n\n\n",
      });

      data.forEach((ticket) => {
        docDefinition.content.push(
          {
            text: [
              {
                text:
                  "Ticket: #" +
                  ticket.ticketNumber +
                  " Status: " +
                  ticket.status +
                  " Date Added: " +
                  new Date(ticket.dateAdded).toLocaleString(),
                bold: true,
              },
              { text: "\n\n" },
            ],
          },
          {
            text: [
              { text: "Email: ", bold: true },
              ticket.email,
              { text: " Category: ", bold: true },
              ticket.category,
              { text: "\n\n" },
            ],
          },
          {
            text: [
              { text: "Time: ", bold: true },
              " " + ticket.timeEntrySum + " Minutes - ",
              { text: " Thread Count: ", bold: true },
              ticket.timeEntryCount,
              "\n\n",
              { text: "Subject: ", bold: true },
              ticket.subject,
              "\n\n",
            ],
          }
        );

        //now to threads

        if (this.exportOptions.showThreads) {
          //sort the threads by date

          ticket.threads.sort(function (a, b) {
            return new Date(b.date) - new Date(a.date);
          });

          ticket.threads.forEach((thread) => {
            if (thread.active) {
              var to = thread.to
                ? thread.to.toString().replace(/(['"])/g, "")
                : "";
              var from = thread.from
                ? thread.from.toString().replace(/(['"])/g, "")
                : "";
              var content = thread.contentAsPlainText
                ? thread.contentAsPlainText.toString().replace(/(['"])/g, "")
                : "";

              docDefinition.content.push({
                text: [
                  { text: "From: ", bold: true },
                  from,
                  { text: " At: ", bold: true },
                  thread.dateAdded.toLocaleString(),
                ],
              });

              docDefinition.content.push({
                text: [{ text: content }, { text: "\n\n" }],
              });
            }
          });
        }

        if (
          ticket.status == "Closed" &&
          ticket.resolution != "" &&
          ticket.resolution != null
        ) {
          docDefinition.content.push(
            {
              text: "Resolution: ",
              bold: true,
            },
            ticket.resolution
          );
        }

        var ticketDate = new Date(ticket.dateAdded);
        var start = new Date(this.startDate);
        var end = new Date(this.endDate);

        var isAddingNote = false;
        var noteCollection = [];

        if (!this.includedCategoriesInProduct.some(x => x == ticket.category)) {
          //add the note
          isAddingNote = true;
          noteCollection.push('This ticket is included in a seperate product or project and not in this invoice');
        }

        if (ticketDate > end || ticketDate < start) {
          isAddingNote = true;
          noteCollection.push('Time added to ticket opened in a previous month, Ticket Number - ' + ticket.ticketNumber);
        }

        if (isAddingNote) {
          docDefinition.content.push({
            text: '\n\nNotes: ',
            bold: true
          }, noteCollection
          );
        }

        if (this.exportOptions.showComment && ticket.status !== "Closed") {
          if (
            ticket.comments &&
            ticket.comments[0] &&
            ticket.comments[0].content &&
            this.exportOptions.showComment
          ) {
            docDefinition.content.push(
              {
                text: "Last Comment",
                bold: true,
              },
              ticket.comments[0].content
            );
          }
        }

        if (
          ticket.classification != "" &&
          ticket.classification != null &&
          ticket.status != "Closed"
        ) {
          docDefinition.content.push(
            {
              text: "Classification: ",
              bold: true,
            },
            ticket.classification
          );
        }

        docDefinition.content.push({
          text: "\n\n",
        });

        docDefinition.content.push({
          table: {
            headerRows: 1,
            widths: ["100%"],
            body: [[""], [""]],
          },
          layout: "headerLineOnly",
        });

        docDefinition.content.push({
          text: "\n\n",
        });
      });

      pdfMake.createPdf(docDefinition).download(fileName + ".pdf");

      this.innerIsShow = false;
      this.$emit("update:isShow", false);
    },
    async exportTicketsWithThreadsAsCSV() {
      var fileName = await this.getFileName();
      //export

      var ticketDataConfig = {
        startDate: this.startDate.toLocaleString('en-US'),
        endDate: this.endDate.toLocaleString('en-US'),
        includeThreads: this.exportOptions.showThreads,
        companyId: this.companyId,
        includeLatestComment: this.exportOptions.showComment,
        productSku: this.productSku
      };

      var resp = {};
      if (this.byTime) {
        resp = await this.$courier.Zoho.TicketDataByTime(ticketDataConfig);
      } else {
        resp = await this.$courier.Zoho.TicketData(ticketDataConfig);
      }

      var payload = await resp.json();

      var jsonData = [];

      payload.payload.forEach((x) => {
        var objectToPush = {
          Status: x.status,
          Subject: x.subject,
          "Last Comment": "",
          Resolution: "",
          Classification: "",
          Category: x.category,
          Email: x.email,
          DateAdded: x.dateAdded,
          "Time Spent": x.timeEntrySum,
          "Thread Time": "",
          From: "",
          To: "",
          Content: "",
          Notes: ""
        };

        var ticketDate = new Date(x.dateAdded);
        var endDate = new Date(this.endDate);
        var startDate = new Date(this.startDate);

        console.log(ticketDate + ' ' + startDate + ' ' + endDate);

        if (ticketDate > endDate || ticketDate < startDate) {
          objectToPush.Notes = 'Time added to ticket opened in a previous month, Ticket Number - ' + x.ticketNumber
        }

        if (x.classification != "" && x.classification != null) {
          objectToPush.Classification = x.classification;
        }

        if (x.status == "Closed") {
          objectToPush.Resolution = x.resolution;
          delete objectToPush.Classification;
        } else {
          delete objectToPush.Resolution;

          if (
            this.exportOptions.showComment &&
            x.comments &&
            x.comments[0] &&
            x.comments[0].content &&
            x.status != "Closed"
          ) {
            objectToPush["Last Comment"] = x.comments[0].content;
          } else {
            delete objectToPush["Last Comment"];
          }
        }

        jsonData.push(objectToPush);

        if (this.exportOptions.showThreads) {
          x.threads.forEach((thread) => {
            objectToPush = {
              Status: "",
              Subject: "",
              Category: "",
              Resolution: "",
              Email: "",
              DateAdded: "",
              "Time Spent": "",
              "Thread Time": thread.dateAdded,
            };
            objectToPush.From = thread.from;
            objectToPush.To = thread.to;
            objectToPush.Content = thread.contentAsPlainText;
            jsonData.push(objectToPush);
          });
        }
      });



      var lastLine = {
        "Time Spent": 'Total: ' + jsonData.reduce((acc, currentValue) => {
          return parseInt(acc) + Number.parseInt((currentValue["Time Spent"] ? currentValue['Time Spent'] : 0));
        }, 0)
      };

      jsonData.push(lastLine);

      genUtilities.convertJSONtoXLSX(
        Object.keys(jsonData[0]).map((x) => ({ label: x, value: x })),
        jsonData,
        "Export",
        fileName
      );

      this.exportOptions.fileName = "";
      this.exportOptions.fileType = "csv";
      this.innerIsShow = false;
      this.$emit("update:isShow", false);
    },
  },
  data() {
    return {
      includedCategoriesInProduct: [],
      exportOptions: {
        fileName: "",
        fileType: "csv",
        showThreads: false,
        showComment: false,
      },
      isExportLoading: false,
      innerIsShow: false,
    };
  },
};
</script>

<style>

</style>